/**
 * Formats a date, returns a string with full month name (January, February, etc) followed by the year.
 * The year should be 4 numeric characters (2022. 2023 etc)
 * @param {String} date
 * @returns {String}
 */
export const formatDate = (date) => {
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const d = new Date(date);
  return `${monthNames[d.getMonth()]} ${d.getFullYear()}`;
};

export const formatDateLocale = (date, locale, options = null) => {
  const parsedOptions = options || {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };

  return date.toLocaleDateString(
    locale === null ? 'en-GB' : locale,
    parsedOptions
  );
};

export const capitalizeFirstLetter = (
  [first, ...rest],
  locale = navigator.language
) => first.toLocaleUpperCase(locale) + rest.join('');

export const saveAnalyticsCookie = (userSelection) => {
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();
  // expire after 1 years
  date.setTime(new Date(year + 1, month, day));
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `evcgAnalytics=${userSelection};${expires};path=/`;
};

export const saveLanguageCookie = (lang) => {
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();
  // expire after 1 years
  date.setTime(new Date(year + 1, month, day));
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `lang=${lang};${expires};path=/`;
};

export const buildingTypeDisplay = (buildingType) => {
  const map = {
    'individual-flat-or-apartment-building':
      'Individual flat or apartment building',
    'detached-property': 'Detached property',
    'semi-detached-property': 'Semi-detached property',
    bungalow: 'Bungalow',
    'terraced-property': 'Terraced property',
    flat: 'Flat',
  };

  return buildingType in map ? map[buildingType] : buildingType;
};
